define('ordersDetailSupplierEditInvoiceProductionSheetView',[
  'module',
  'marionette',
  'underscore',
  'pdfView',
  'template!ordersDetailSupplierEditInvoiceProductionSheetView'
], function (
  Module,
  Marionette,
  _,
  PdfView,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'orders-detail-body-supplier-edit-invoice-productionsheet-view',

    ui: {
      canvasCtn: '.canvas-ctn'
    },

    events: {
      'click': 'onClick'
    },

    onRender: function () {
      this.renderAttachment();
    },

    renderAttachment: function () {
      if (!this.model.get('productionSheet') || !this.model.get('productionSheet').content) {
        return;
      }

      // Loaded via <script> tag, create shortcut to access PDF.js exports.
      var pdfjsLib = window['pdfjs-dist/build/pdf'];
      pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.2.228/pdf.worker.min.js';

      var dataURI = 'data:application/pdf;base64, ' + this.model.get('productionSheet').content;
      var loadingTask = pdfjsLib.getDocument(dataURI);

      loadingTask.promise.then(_.bind(function (pdf) {
        var numPages = pdf.numPages;
        // Clear any previous render (e.g. on re-render)
        this.ui.canvasCtn.empty();

        // Render every page sequentially into its own canvas element
        var renderPage = _.bind(function (pageNumber) {
          if (pageNumber > numPages) return;

          pdf.getPage(pageNumber).then(_.bind(function (page) {
            var scale = 2;
            var viewport = page.getViewport({ scale: scale });

            var canvas = document.createElement('canvas');
            canvas.className = 'canvas page-' + pageNumber;
            canvas.height = viewport.height;
            canvas.width = viewport.width;
            this.ui.canvasCtn[0].appendChild(canvas);

            var renderContext = {
              canvasContext: canvas.getContext('2d'),
              viewport: viewport
            };

            page.render(renderContext).promise.then(_.bind(function () {
              renderPage(pageNumber + 1);
            }, this));
          }, this));
        }, this);

        renderPage(1);
      }, this), _.bind(function (reason) {
        console.error(reason);
      }, this));
    },

    // Static methods
    open: function (data) {
      require([
        'windows',
        'ordersDetailSupplierEditInvoiceProductionSheetView'
      ], function (Windows, View) {
        var title = '';

        if (data.model.get('productionSheet') && data.model.get('productionSheet').filename)
          title = data.model.get('productionSheet').filename;

        Windows.open({
          view: _.bind(function () {
            return new View(data);
          }, this),
          title: title,
          modal: true,
          height: '90%',
          width: '70%'
        });
      });
    }
  });
});

